import { render, staticRenderFns } from "./ModalSignature.vue?vue&type=template&id=0f5af2ff&scoped=true&"
import script from "./ModalSignature.vue?vue&type=script&lang=js&"
export * from "./ModalSignature.vue?vue&type=script&lang=js&"
import style0 from "./ModalSignature.vue?vue&type=style&index=0&id=0f5af2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5af2ff",
  null
  
)

export default component.exports